<div class="informaje-o-obiekcie obiekt" *ngIf="informacjeOKliknietejPozycji" [style.left]="polozenieOknaOdLewej+'px'"
  [style.top]="polozenieOknaOdGory+'px'">
  <div class="kontener-info-window">
    <div class="naglowek" (swipeleft)="nastepnyObiekt()" (swiperight)="poprzedniObiekt()"
      *ngIf="wybranaWarstwaDoWyswietlenia && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt]">
      <span *mmTylkoMobile>
        <span class="naglowek-c" #dlugaNazwa mmDlugieNazwy [liczbaWierszy]="3">
          <span class="naglowek-nazwa">
            {{wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].tytul}}
          </span>
        </span>
      </span>
      <span *mmTylkoDesktop class="naglowek-naglowek">
        <span class="naglowek-c" #dlugaNazwa mmDlugieNazwy>
          <span class="naglowek-nazwa">
            {{wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].tytul}}
          </span>
        </span>

      </span>
      <span *mmTylkoDesktop>
        <div class="logo-partnera-n-wrapper" *ngIf="mapa?.partnerzy && wybranaWarstwaDoWyswietlenia.uuidWarstwy !=='test-uuid-warstwy'
          && !wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].logo">
          <div class="logo-partnera-n" *ngFor="let part of mapa!.partnerzy!">
            <img [src]="aktualnyJezyk==='pl' ? part.logoSrc : part.logoSrcEn!"
              [alt]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn!"
              [matTooltip]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn!" />
          </div>
        </div>
        <div class="logo-partnera-n-wrapper" *ngIf="wybranaWarstwaDoWyswietlenia
             && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt]
             && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].logo">
          <div class="logo-partnera-n"
            *ngFor="let part of wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].logoPartnerowDlaObiektu">
            <img [src]="aktualnyJezyk==='pl' ? part.logoSrc : part.logoSrcEn ? part.logoSrcEn : part.logoSrc"
              [alt]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn ? part.nazwaEn : part.nazwa"
              [matTooltip]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn ? part.nazwaEn : part.nazwa" />
          </div>
        </div>
      </span>


    </div>

    <div class="zawartosc" [class.z-nawigacja]="liczbaObiektow>1">
      <mm-przewijany-komponent>
        <div (swipeleft)="nastepnyObiekt()" (swiperight)="poprzedniObiekt()">
          <span *mmTylkoMobile>
            <div class="flex logo-partnera gap-3 justify-start" *ngIf="mapa!.partnerzy && wybranaWarstwaDoWyswietlenia!.uuidWarstwy! !=='test-uuid-warstwy'
            && !wybranaWarstwaDoWyswietlenia!.obiekty[wybranaWarstwaDoWyswietlenia!.aktualnyObiekt].logo">

              <div class="flex logo-partnera items-center" *ngFor="let part of mapa!.partnerzy!">
                <img [src]="aktualnyJezyk==='pl' ? part.logoSrc : part.logoSrcEn!" width="100px" height="48px"
                  [alt]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn!"
                  [matTooltip]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn!" />
              </div>
            </div>
            <div *ngIf="wybranaWarstwaDoWyswietlenia
             && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt]
             && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].logo"
              class="wielu-partnerow">
              <div
                *ngFor="let part of wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].logoPartnerowDlaObiektu">
                <img [src]="aktualnyJezyk==='pl' ? part.logoSrc : part.logoSrcEn ? part.logoSrcEn : part.logoSrc"
                  width="70px" height="48px"
                  [alt]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn ? part.nazwaEn : part.nazwa"
                  [matTooltip]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn ? part.nazwaEn : part.nazwa" />
              </div>
            </div>
          </span>
          <div class="logo-partnera-z-wrapper" *ngIf="wybranaWarstwaDoWyswietlenia!.uuidWarstwy==='test-uuid-warstwy'">
            <div class="logo-partnera-z"
              *ngFor="let part of wybranaWarstwaDoWyswietlenia!.obiekty[wybranaWarstwaDoWyswietlenia!.aktualnyObiekt].partnerzyLista">
              <img [src]="aktualnyJezyk==='pl' ? part.logoSrc : part.logoSrcEn ? part.logoSrcEn : part.logoSrc"
                [alt]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn ? part.nazwaEn : part.nazwa"
                [matTooltip]="aktualnyJezyk==='pl' ? part.nazwa : part.nazwaEn ? part.nazwaEn : part.nazwa" />
            </div>

            <!-- <img *ngIf="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partnerzy"
          [src]="aktualnyJezyk==='pl' ? wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partnerzyLista[0]!.logoSrc : wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partner?.logoSrcEn"
          width="100px" height="48px"
          [alt]="aktualnyJezyk==='pl' ? wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partner?.nazwa : wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partner?.nazwaEn!"
          [matTooltip]="aktualnyJezyk==='pl' ? wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partner?.nazwa! : wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].partner?.nazwaEn!" /> -->

          </div>

          <mm-obiekt-opis *ngIf="sekcjeOkna && sekcjeOkna.opis.widoczna && wybranaWarstwaDoWyswietlenia"
            [obiekt]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt]"
            [nazwaWarstwy]="wybranaWarstwaDoWyswietlenia.warstwa.nazwaOficjalna">
          </mm-obiekt-opis>
          <mm-expandable-panel
            *ngIf="sekcjeOkna
              && sekcjeOkna.opis.widoczna
              && wybranaWarstwaDoWyswietlenia
              && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].opisExpandableContent"
            [header]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].opisExpandableHeader+'' || 'Opisy'"
            [content]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].opisExpandableContent+''">
          </mm-expandable-panel>
        </div>
        <mm-obiekt-zalaczniki-i-zdjecia *ngIf="sekcjeOkna && wybranaWarstwaDoWyswietlenia"
          [warstwa]="wybranaWarstwaDoWyswietlenia.warstwa" [sekcjeOkna]="sekcjeOkna" [mapa]="mapa"
          [obiekt]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt]">
        </mm-obiekt-zalaczniki-i-zdjecia>
        <mm-obiekt-tagi
          *ngIf="sekcjeOkna && sekcjeOkna.opis.widoczna && wybranaWarstwaDoWyswietlenia && wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].tagi != ''"
          [tagi]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].tagi!"
          (zamknij)="zamknij()">
        </mm-obiekt-tagi>
        <div class="informacje-o-lokalizacji" (swipeleft)="nastepnyObiekt()" (swiperight)="poprzedniObiekt()"
          *ngIf="sekcjeOkna  && wybranaWarstwaDoWyswietlenia">
          <mm-lokalizacja-opis [warstwa]="wybranaWarstwaDoWyswietlenia.warstwa"
            [obiektDoLinku]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt]"
            [pozycjaGeograficzna]="wybranaWarstwaDoWyswietlenia.obiekty[wybranaWarstwaDoWyswietlenia.aktualnyObiekt].pozycja"
            [obiekt]="true"></mm-lokalizacja-opis>
        </div>
      </mm-przewijany-komponent>
    </div>
  </div>
  <div class="nawigacja-po-obiektach" *ngIf="liczbaObiektow>1">
    <div class="licznik">{{numerAktualnegoObiektu}} {{'codes.modul-mapowy.generyczne.paginacja-z' | translate}}
      {{liczbaObiektow}}
    </div>
    <div class="nawigacja" (click)="poprzedniObiekt()">
      <mm-przycisk-ikona ikona="poprzedni" typ="'czarno-bialy'"></mm-przycisk-ikona>
    </div>
    <div class="nawigacja" (click)="nastepnyObiekt()">
      <mm-przycisk-ikona ikona="nastepny" typ="'czarno-bialy'"></mm-przycisk-ikona>
    </div>
  </div>
  <div class="zamknij" *ngIf="informacjeOKliknietejPozycji?.zadokowane">
    <mm-przycisk-ikona label="{{'codes.modul-mapowy.generyczne.zamknij' | translate}}" ikona="zamknij"
      typ="przezroczysty" (click)="zamknij()"></mm-przycisk-ikona>
  </div>
</div>
